import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PythonTema4 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema4_Funciones.pdf`;
  /*const pdfUrl = "/pdf/Tema4_Funciones.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Tema 4: Funciones</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Tema 4: Funciones" />
      </Container>
    </>
  );
};

 export default PythonTema4;
